const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilesArchiveSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EA8953"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M505.056,315.152L376.592,186.688v-0.053l-48-47.947l-32-32H135.419 v266.667l137.989,137.989C386.64,503.733,479.643,422.539,505.056,315.152z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBF0F3"
    },
    points: "296.613,106.667 135.397,106.667 135.397,373.333 344.603,373.333 344.603,154.656 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D5D6DB"
    },
    points: "296.613,154.656 344.603,154.656 296.613,106.667  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.672,
    y: 180.779,
    style: {
      fill: "#D5D6DB"
    },
    width: 166.667,
    height: 5.333
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.672,
    y: 205.333,
    style: {
      fill: "#D5D6DB"
    },
    width: 166.667,
    height: 5.333
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.672,
    y: 229.867,
    style: {
      fill: "#D5D6DB"
    },
    width: 166.667,
    height: 5.333
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.672,
    y: 254.453,
    style: {
      fill: "#D5D6DB"
    },
    width: 112,
    height: 5.333
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.672,
    y: 278.987,
    style: {
      fill: "#D5D6DB"
    },
    width: 166.667,
    height: 5.333
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.672,
    y: 303.573,
    style: {
      fill: "#D5D6DB"
    },
    width: 166.667,
    height: 5.333
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.672,
    y: 328.107,
    style: {
      fill: "#D5D6DB"
    },
    width: 166.667,
    height: 5.333
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.672,
    y: 352.693,
    style: {
      fill: "#D5D6DB"
    },
    width: 83.328,
    height: 5.333
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "328.613,138.667 167.397,138.667 167.397,405.333 376.603,405.333 376.603,186.656 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBF0F3"
    },
    points: "328.613,186.656 376.603,186.656 328.613,138.667  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.693,
    y: 212.779,
    style: {
      fill: "#EBF0F3"
    },
    width: 166.667,
    height: 5.333
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.693,
    y: 237.333,
    style: {
      fill: "#EBF0F3"
    },
    width: 166.667,
    height: 5.333
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.693,
    y: 261.867,
    style: {
      fill: "#EBF0F3"
    },
    width: 166.667,
    height: 5.333
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.693,
    y: 286.453,
    style: {
      fill: "#EBF0F3"
    },
    width: 112,
    height: 5.333
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.693,
    y: 310.987,
    style: {
      fill: "#EBF0F3"
    },
    width: 166.667,
    height: 5.333
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.693,
    y: 335.573,
    style: {
      fill: "#EBF0F3"
    },
    width: 166.667,
    height: 5.333
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.693,
    y: 360.107,
    style: {
      fill: "#EBF0F3"
    },
    width: 166.667,
    height: 5.333
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.693,
    y: 384.693,
    style: {
      fill: "#EBF0F3"
    },
    width: 83.328,
    height: 5.333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilesArchiveSvgrepoCom);
export default __webpack_public_path__ + "static/media/files-archive-svgrepo-com.1a3769b06b3c383ea50561c04463bdbb.svg";
export { ForwardRef as ReactComponent };